import styled from '@emotion/styled';
import { display, flexbox, palette, positions, sizing, spacing } from '@material-ui/system';
import React from 'react';

export const Box = styled.div`${flexbox}${sizing}${spacing}${palette}${display}${positions}`;

export const Wrapper = props => {
	return (
		<Box maxWidth={['100%', '100%', '900px', '1200px', '1444px']} mx="auto" {...props}>
			{props.children}
		</Box>
	);
};

export default Box;
